<template>
    <div class="container">
        <div class="row">
            <ul class="nav nav-pills">
                <li role="presentation">
                    <a href="/" class="btn btn-default" ><i class="fa fa-history"></i> Voltar </a>
                </li>

            </ul>
        </div>
        <br>
        <div class="row">
            <div class="col-md-12">
                <v-table :column="colunas" :data="dataComputed"  :actions="actionsTable"  @show='show'></v-table>
            </div>

        </div>
<!-------------------  MODAL DE EDITAR / CRIAR UM NOVO LEAD ------------------------->
        <div class="modal fade" id="relatorio" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title"></h3>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                    <div class="form-group">
                        <label>Tipo: </label>
                        <select class="form-control" v-model="tipo">
                            <option value="DISTRIBUIDOR">Distribuidor</option>
                            <option value="REVENDEDORA">Revendedora</option>
                            <option value="CONSUMIDOR">Consumidor</option>
                        </select>
                    </div>
                        <div class="form-group">
                            <label>Nome: </label>
                            <input type="text" class="form-control" v-model="nome"/>
                        </div>
                        <div class="form-group">
                            <label>Telefone: </label>
                            <input type="text" class="form-control" v-model="telefone"/>
                        </div>
                    </div>
                    <div class="modal-footer">

                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>



    export default {
        components: {},
        data(){
            return{
                datePickerConfig:{
                    'format':'D/MM/YYYY',
                    'showClose': true
                },
                search:"",
                colunas:[
                    ["Nome","nome"],["Estado","uf"],['Status','status'],['Tipo','tipo'],['Data','data']
                ],
                data:[],
                actionsTable:['show'],
                telefone:'',
                nome:'',
                cpf:'',
                tipo:''

            }
        },
        methods: {

            loadData: function () {
                let data = {
                    from: this.fromDate.format("Y-M-D"),
                    to: this.toDate.format("Y-M-D"),
                    status: this.status,
                    tipo:this.tipo
                };
                var vm = this;
                $('.loading').show();

                axios.get('/adm/integrasite/list',{
                    params:data
                }).then(function (response) {
                    vm.formatDataToTable( response.data );
                    $('.loading').hide();
                }).catch(function (error) {
                    console.log(error);
                    $('.loading').hide();
                });


            },
            formatDataToTable(dataLoaded){

                var data = [];
                dataLoaded.forEach(function(el,index){
                    let obj = {};
                    obj.id = el.id;
                    obj.nome = el.nome;
                    obj.status = el.status;
                    obj.estado = el.uf;
                    obj.tipo = el.tipo;
                    obj.data = new Date(el.data).toLocaleDateString();
                    data.push(obj);
                });

                this.data = data;
            },
            show: function(id){

                var vm = this;
                var obj = [];

                $('.loading').show();
                axios.get('/adm/integrasite/'+ id).then(function(response){
                    obj = response.data;
                    vm.listaRevendedora = obj;

                }).catch(function(errors){
                    console.log(errors);
                    $('.loading').hide();
                });

                console.log(vm.listaRevendedora);

                $('.loading').hide()
                $('.modal-title').html('Editando/Visualizando Lead');
                $('#relatorio').modal()

            },
            add:function () {
                $('.modal-title').html('Novo Lead')
                $('#relatorio').modal()
            }


        },
        computed:{
            actionsTable: function(){
                console.log(this.data);
                var actions = ['show'];
                return actions;
            },

            filteredData(){
                return this.data.filter(item => {
                    return item.id.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                });
            },
            dataComputed(){
                return this.data;
            }
        },
        created:function(){
            $('.loading').show();
        },
        mounted(){
            this.getFat();

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/adm_lead/index.vue